import { render, staticRenderFns } from "./margin-commission.vue?vue&type=template&id=170e1de2&scoped=true&"
import script from "./margin-commission.vue?vue&type=script&lang=js&"
export * from "./margin-commission.vue?vue&type=script&lang=js&"
import style0 from "./margin-commission.vue?vue&type=style&index=0&id=170e1de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e1de2",
  null
  
)

export default component.exports